import React, { useEffect, useState } from 'react';
import { nanoid } from 'nanoid';

import {
	Typography,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Grid,
	FormControl,
	Select,
	MenuItem,
	Button,
	InputLabel,
	Divider,
	FormHelperText,
	TextField,
	Paper,
	Box,
} from '@mui/material';

import { ExpandMore, Delete } from '@mui/icons-material';

import { obtenerFallas } from '../../../services/falla.service';

import { upload } from '../../../services/imagenes.service';

import { styled } from '@mui/material/styles';

const AccordionDetailsCustom = styled(AccordionDetails)`
	display: flex;
	justify-content: center;
`;

export default function Servicio(props) {
	const tiposDeServicios = [
		{
			tipo: ' ',
			label: '',
			disabled: true,
		},
		{
			tipo: 'evaluacion',
			label: 'Evaluación',
			disabled: false,
		},
		{
			tipo: 'reparacion',
			label: 'Reparación',
			disabled: false,
		},
		{
			tipo: 'reparacion por garantia',
			label: 'reparación por garantía',
			disabled: false,
		},
	];

	const baseServicio = {
		id: nanoid(),
		tipo_servicio: 'evaluacion',
		descrip_servicio: 'Evaluación',
		id_falla: '25',
		costo: 'Seleccione una falla',
		imagenes: [],
		estado: 'pendiente por calidad',
	};

	const [dataServicios, setDataServicios] = useState([baseServicio]);

	const borrarServicio = (servicioId) => {
		const newDataServicio = [...dataServicios];
		const index = newDataServicio.findIndex(
			(servicio) => servicio.id === servicioId
		);

		newDataServicio.splice(index, 1);
		console.log(newDataServicio);
		setDataServicios(newDataServicio);
		props.getServiciosFromComponent(newDataServicio);
	};

	const updateService = (serviceId, event) => {
		const { name, value } = event;

		const newDataServicios = [...dataServicios];

		const index = newDataServicios.findIndex(
			(servicio) => servicio.id === serviceId
		);

		newDataServicios[index][name] = value;

		if (name === 'id_falla') {
			const indexFalla = fallas.findIndex((falla) => falla.id_falla === value);
			const costo = fallas[indexFalla].costo;
			newDataServicios[index].costo = costo;
		}

		setDataServicios(newDataServicios);

		props.getServiciosFromComponent(newDataServicios);
	};

	const [fallas, setFallas] = useState([
		{
			id_falla: ' ',
			nombre_falla: 'Selecciona una falla',
			costo: 'Selecciona una falla',
		},
	]);

	const selectFile = async (index, event) => {
		const selectedFiles = event.files;
		const selectedFilesArray = Array.from(selectedFiles);
		const formData = new FormData();

		for (const image in selectedFilesArray) {
			formData.append('images', selectedFilesArray[image]);
		}

		await upload(formData)
			.then((response) => {
				const storedImages = response.data;

				const indexServicio = dataServicios.findIndex(
					(servicio) => servicio.id === index
				);

				let newDataServicios = [...dataServicios];

				newDataServicios[indexServicio].imagenes =
					newDataServicios[indexServicio].imagenes.concat(storedImages);

				setDataServicios(newDataServicios);
			})
			.catch((err) => {
				console.log(err);
			});
	};

	useEffect(() => {
		obtenerFallas()
			.then((response) => {
				setFallas((fallas) => fallas.concat(response.data));
			})
			.catch((err) => {
				console.log(err);
			});
	}, []);

	return (
		<Paper variant="outlined" sx={{ p: 2, width: '100%', backgroundColor: '#f9f9f9' }}>
 

  {dataServicios.map((servicio, i) => (
    <Box key={servicio.id} sx={{ mb: 3 }}>
      
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel id={`tipo-servicio-label-${i}`}>Tipo de servicio</InputLabel>
            <Select
              labelId={`tipo-servicio-label-${i}`}
              name="tipo_servicio"
              label="Tipo de servicio"
              value={dataServicios[i].tipo_servicio}
              onChange={(event) => updateService(servicio.id, event.target)}
            >
              {tiposDeServicios.map((serv, j) => (
                <MenuItem key={j} value={serv.tipo} disabled={serv.disabled}>
                  {serv.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel id={`falla-label-${i}`}>Detalle de falla</InputLabel>
            <Select
              labelId={`falla-label-${i}`}
              name="id_falla"
              label="Detalle de falla"
              value={dataServicios[i].id_falla}
              onChange={(event) => {
                event.target.costo = dataServicios[i].costo;
                updateService(servicio.id, event.target);
              }}
              displayEmpty
            >
              {fallas.map((falla, j) => (
                <MenuItem key={j} value={falla.id_falla}>
                  {falla.nombre_falla}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      {dataServicios[i].imagenes.length > 0 && (
        <Box sx={{ mt: 2 }}>
          <Divider sx={{ mb: 1 }} />
          <Grid container spacing={2}>
            {dataServicios[i].imagenes.map((image) => (
              <Grid item xs={4} key={nanoid()}>
                <img
                  src={`http://localhost:8080/api/uploads/${image}`}
                  alt={image}
                  style={{ maxWidth: '100%', maxHeight: '300px', borderRadius: 4 }}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </Box>
  ))}
</Paper>

	);
}
